import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Input from '../../../../Components/Forms/Input';
import { vatPattern, useSettings } from '../../Validate';

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(auto-fit, 50px);
  grid-gap: 20px;
`;

const General = ({ settings, setValues }) => {
  const { values, handleChange } = useSettings(settings, setValues);
  return (
    <Container>
      <Input
        label="Tid i varukorgen"
        type="text"
        name="basketTime"
        value={values.basketTime}
        onChange={handleChange}
        pattern={vatPattern}
        required
      />
    </Container>
  );
};

General.propTypes = {
  settings: PropTypes.shape({
    vat: PropTypes.string
  }).isRequired,
  setValues: PropTypes.func.isRequired
};

export default General;
